module.exports = __webpack_public_path__ + "static/media/user-checklist-background-bottom.4b014024.png";